<template>
  <section
    class="component-dacacb90"
    resmed-component-name="product_ratings_carousel_icon-line_text"
    v-bind:style="{
      background: acf.layout['background'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h5>{{ acf.title }}</h5>
              <h2 v-html="acf.headline"></h2>
              <p class="mb-4" v-html="acf.description"></p>
            </div>
          </div>
        </div>
      </div>

      <div style="overflow: hidden" class="swiper-wrapper">
        <div class="swiper container">
          <div class="row">
            <div class="col p-0">
              <div class="seek">
                <div
                  class="seek-wrapper"
                  v-show="
                    ['lg', 'xl'].includes($root.mode) && acf.cards.length > 3
                  "
                >
                  <a
                    ref="swiperButtonPrev"
                    href="#"
                    class="btn navigation-icon left-caret swiper-button-prev"
                  ></a>
                  <a
                    ref="swiperButtonNext"
                    href="#"
                    class="btn navigation-icon right-caret swiper-button-next"
                  ></a>
                </div>

                <div
                  ref="swiperContainer"
                  class="stage swiper-container slider"
                  v-bind:class="`-mode-${[$root.mode]}`"
                >
                  <div
                    class="items swiper-wrapper"
                    v-bind:class="{
                      '-justify-content-center': acf.cards.length < 3,
                    }"
                  >
                    <div
                      class="item swiper-slide mb-3 mb-md-0"
                      v-for="(item, index) in acf.cards"
                    >
                      <div class="wrapper">
                        <div
                          class="rating"
                          v-bind:class="[`n-${item.rating}`]"
                        ></div>
                        <div v-html="item.comment" class="comment"></div>
                        <p>{{ item.name }}<br />{{ item.state }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-show="
              (['xs', 'sm'].includes($root.mode) && acf.cards.length > 1) ||
              (['md', 'lg', 'xl'].includes($root.mode) && acf.cards.length > 3)
            "
          >
            <div class="col">
              <div ref="swiperPagination" class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-dacacb90", // product_ratings_carousel_icon-line_text
  props: ["acf"],
  data() {
    return {
      slider: undefined,
      overflow: true,
    };
  },
  mixins: [helper],
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-dacacb90 {
  padding: 5rem 0 4rem 0;
}

.component {
  &.text-color-white {
    h5 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    margin-bottom: 1.5rem;
  }

  h4 {
    margin-bottom: 0.325rem;
    color: $cc-resmed-white;
  }

  h5 {
    position: relative;
    margin-bottom: 0.75rem;

    @extend %eyebrow-center;
  }

  .stage {
    .items {
      display: flex;
      align-items: stretch;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;

      &.-justify-content-center {
        @media (min-width: 992px) {
          justify-content: center;
        }
      }
    }

    .item {
      padding: 0 0.5rem;
      display: flex;
      flex-shrink: 0;
      align-items: stretch;
    }

    .item {
      padding: 0 0.625rem;

      &:nth-child(3n + 1) {
        > div {
          background-color: #3d87be;
        }
      }
      &:nth-child(3n + 2) {
        > div {
          background-color: #5a3587;
        }
      }
      &:nth-child(3n + 3) {
        > div {
          background-color: #4458a1;
        }
      }

      > div {
        display: flex;
        flex-direction: column;

        padding: 2rem;
        box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        overflow: hidden;
        text-align: center;

        * {
          color: $cc-resmed-white;

          font-size: 1.125rem; // exception
          font-family: "Plus Jakarta Sans", sans-serif;
          font-weight: 500;
        }
      }

      .rating {
        background-size: 130px;
        background-repeat: no-repeat;
        background-position: center 1rem;
        padding: 0rem 0 4rem 0;

        @for $i from 1 through 5 {
          &.n-#{$i} {
            background-image: url(#{$assets}/images/star-ratings-#{$i}.svg);
          }
        }
      }

      .comment {
        flex-grow: 1;
        margin-bottom: 2rem;
      }
    }
  }

  @media (max-width: 767px) {
    .overflow {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .swiper {
      max-width: none;
      width: 90vw !important;
    }
  }

  .text-color-reverse {
    h4,
    p {
      color: $cc-resmed-black;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-4rem) scale(1.4);
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(4rem) scale(1.4);
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      position: relative;
      width: 100%;
      height: 100%;

      overflow: hidden;
      padding: 1rem 0 2rem 0;
      margin: 0 auto;
      z-index: 1;
    }

    .items {
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: stretch;

      padding: 0 0.725rem;
      width: 33.33%;
    }
  }
}
</style>